module.exports = __webpack_public_path__ + "static/10.b809c945.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/MasterTheses/10.png
// module id = 823
// module chunks = 39236203315009 172526442442348